package com.example.monetix.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Boolean
import kotlin.Long
import kotlin.String

public class SavingsGoalQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> all(mapper: (
    id: String,
    name: String,
    targetAmountCents: Long,
    savedAmountCents: Long,
    emoji: String?,
    imageUri: String?,
    isCompleted: Boolean,
    isDeleted: Boolean,
    createdAtEpochMs: Long,
    updatedAtEpochMs: Long,
  ) -> T): Query<T> = Query(964_075_502, arrayOf("SavingsGoalEntity"), driver, "SavingsGoal.sq",
      "all",
      "SELECT SavingsGoalEntity.id, SavingsGoalEntity.name, SavingsGoalEntity.targetAmountCents, SavingsGoalEntity.savedAmountCents, SavingsGoalEntity.emoji, SavingsGoalEntity.imageUri, SavingsGoalEntity.isCompleted, SavingsGoalEntity.isDeleted, SavingsGoalEntity.createdAtEpochMs, SavingsGoalEntity.updatedAtEpochMs FROM SavingsGoalEntity WHERE isDeleted = 0") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getLong(2)!!,
      cursor.getLong(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getBoolean(6)!!,
      cursor.getBoolean(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!
    )
  }

  public fun all(): Query<SavingsGoalEntity> = all { id, name, targetAmountCents, savedAmountCents,
      emoji, imageUri, isCompleted, isDeleted, createdAtEpochMs, updatedAtEpochMs ->
    SavingsGoalEntity(
      id,
      name,
      targetAmountCents,
      savedAmountCents,
      emoji,
      imageUri,
      isCompleted,
      isDeleted,
      createdAtEpochMs,
      updatedAtEpochMs
    )
  }

  public fun <T : Any> allIncludingDeleted(mapper: (
    id: String,
    name: String,
    targetAmountCents: Long,
    savedAmountCents: Long,
    emoji: String?,
    imageUri: String?,
    isCompleted: Boolean,
    isDeleted: Boolean,
    createdAtEpochMs: Long,
    updatedAtEpochMs: Long,
  ) -> T): Query<T> = Query(326_761_730, arrayOf("SavingsGoalEntity"), driver, "SavingsGoal.sq",
      "allIncludingDeleted",
      "SELECT SavingsGoalEntity.id, SavingsGoalEntity.name, SavingsGoalEntity.targetAmountCents, SavingsGoalEntity.savedAmountCents, SavingsGoalEntity.emoji, SavingsGoalEntity.imageUri, SavingsGoalEntity.isCompleted, SavingsGoalEntity.isDeleted, SavingsGoalEntity.createdAtEpochMs, SavingsGoalEntity.updatedAtEpochMs FROM SavingsGoalEntity") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getLong(2)!!,
      cursor.getLong(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getBoolean(6)!!,
      cursor.getBoolean(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!
    )
  }

  public fun allIncludingDeleted(): Query<SavingsGoalEntity> = allIncludingDeleted { id, name,
      targetAmountCents, savedAmountCents, emoji, imageUri, isCompleted, isDeleted,
      createdAtEpochMs, updatedAtEpochMs ->
    SavingsGoalEntity(
      id,
      name,
      targetAmountCents,
      savedAmountCents,
      emoji,
      imageUri,
      isCompleted,
      isDeleted,
      createdAtEpochMs,
      updatedAtEpochMs
    )
  }

  public suspend fun upsert(
    id: String,
    name: String,
    targetAmountCents: Long,
    savedAmountCents: Long,
    emoji: String?,
    imageUri: String?,
    isCompleted: Boolean,
    isDeleted: Boolean,
    createdAtEpochMs: Long,
    updatedAtEpochMs: Long,
  ) {
    driver.execute(903_558_082,
        """INSERT OR REPLACE INTO SavingsGoalEntity VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?)""", 10) {
          bindString(0, id)
          bindString(1, name)
          bindLong(2, targetAmountCents)
          bindLong(3, savedAmountCents)
          bindString(4, emoji)
          bindString(5, imageUri)
          bindBoolean(6, isCompleted)
          bindBoolean(7, isDeleted)
          bindLong(8, createdAtEpochMs)
          bindLong(9, updatedAtEpochMs)
        }.await()
    notifyQueries(903_558_082) { emit ->
      emit("SavingsGoalEntity")
    }
  }

  public suspend fun delete(id: String) {
    driver.execute(406_495_294, """DELETE FROM SavingsGoalEntity WHERE id = ?""", 1) {
          bindString(0, id)
        }.await()
    notifyQueries(406_495_294) { emit ->
      emit("SavingsGoalEntity")
    }
  }

  public suspend fun softDelete(updatedAtEpochMs: Long, id: String) {
    driver.execute(-1_328_629_880,
        """UPDATE SavingsGoalEntity SET isDeleted = 1, updatedAtEpochMs = ? WHERE id = ?""", 2) {
          bindLong(0, updatedAtEpochMs)
          bindString(1, id)
        }.await()
    notifyQueries(-1_328_629_880) { emit ->
      emit("SavingsGoalEntity")
    }
  }
}
